export default class Config {

    public static API_ROOT = 'http://' + window.location.hostname + ':3001/';
}
